/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRedo = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M7.996 5c1.603 0 3.11.624 4.243 1.757l7.757 7.816V9h2v9h-9v-2l5.597-.001-7.77-7.83a4.004 4.004 0 0 0-5.655.002 4.005 4.005 0 0 0 0 5.658l2.525 2.454L6.3 17.717l-2.536-2.464c-2.35-2.35-2.35-6.156-.01-8.496A5.96 5.96 0 0 1 7.996 5z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgRedo as Redo };
